<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/walletindex' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>钱包</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>账期冻结明细</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-row mt-0">
        <div class="toolbar-item" id="auto-0">
          <span class="item-label">下单日期</span>
          <el-date-picker
            v-model="queryDate"
            type="month"
            placeholder="请选择日期"
            value-format="yyyyMM"
            @change="changeTime"
          >
          </el-date-picker>
        </div>
        <div class="toolbar-item" id="auto-1">
          <el-button type="primary" size="small" @click="screen">筛选</el-button>
        </div>
      </div>
    </div>

    <div class="table-custom-box" id="auto-2">
      <fe-table
        :tableData="tableData"
        :columns="columns"
        border
        :show-pagination="false"
        :pagination-config="pagination"
        @pagination-current-change="handleCurrentChange"
        @pagination-size-change="handleSizeChange"
      >
        <!-- 下单日期 -->
        <template #payDate="{ scope }">
          <span>{{ scope.row.payDate | stamp2TextDate }}</span>
        </template>
        <!-- 冻结金额 -->
        <template #tradeAmt="{ scope }">
          <span class="font-orange">{{ scope.row.tradeAmt | thousands(2) }}元</span>
        </template>
      </fe-table>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:2
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import tableMixin from '@/utils/tableMixin';
import dayjs from 'dayjs';

export default {
  name: 'ActperiodFrozen',
  mixins: [tableMixin],
  data: function () {
    return {
      columns: [
        { label: '下单日期', prop: 'payDate', 'min-width': 120 },
        { label: '运单号', prop: 'orderNumber', 'min-width': 120 },
        { label: '冻结金额', prop: 'tradeAmt', 'min-width': 120 }
      ],
      //   axiosConfig: { url: api.queryLaterPayFrozeResultListForCompany }, // 列表接口
      queryDate: '',
      tableOptions: {
        queryDate: null
      } //筛选条件
    };
  },
  methods: {
    async screen() {
      if (!this.tableOptions.queryDate) {
        this.$message.warning('请选择查询日期');
        return;
      }
      let res = await axios.post(api.queryLaterPayFrozeResultListForCompany, {
        queryDate: this.tableOptions.queryDate
      });
      res.data = res.data || {};
      this.tableData = res.data.list || [];
    },
    changeTime(val) {
      this.tableOptions.queryDate = val ? dayjs(val).unix() * 1000 : null;
    }
  }
};
</script>
